// @flow
import urlJoin from 'url-join';

const {
  REACT_APP_ENVIRONMENT,
  REACT_APP_COUNTRY_CODE,
  REACT_APP_LANGUAGE_CODE,
} = process.env;

export function navigateToLegacyFrontpage() {
  navigateToLegacyPage('DNB/frontpage/eBankingFrontpage.aspx');
}

export function navigateToLegacyPage(url: string, newTab: false) {
  const legacyBaseUrl = getLegacyBaseUrl(
    REACT_APP_ENVIRONMENT,
    REACT_APP_COUNTRY_CODE,
    REACT_APP_LANGUAGE_CODE
  );
  const destinationUrl = urlJoin(legacyBaseUrl, url);
  if (newTab) {
    window.open(destinationUrl, '_blank');
  } else {
    document.location.href = destinationUrl;
  }
}

function getLegacyBaseUrl(environment, country, language) {
  return `${protocol[environment.toUpperCase()]}://${
    envPrefx[environment.toUpperCase()]
  }${baseUrl[country.toUpperCase()][language.toUpperCase()]}/`;
}

const protocol = {
  TEST: 'http',
  SYST: 'https',
  PROD: 'https',
};

const envPrefx = {
  TEST: 'test-',
  SYST: 'syst-',
  PROD: '',
};

const baseUrl = {
  DK: {
    DA: 'netbank2.danskebank.dk',
    EN: 'ebanking2.danskebank.dk',
  },
  NO: {
    NB: 'nettbank2.danskebank.no',
    EN: 'nettbank2.danskebank.no',
  },
  SE: {
    SV: 'hembanken2.danskebank.se',
    EN: 'hembanken2.danskebank.se',
  },
  FI: {
    FI: 'verkkopankki2.danskebank.fi',
    SV: 'webbank2.danskebank.fi',
    EN: 'ebanking2.danskebank.fi',
  },
  GB: {
    EN: 'ebanking2.danskebank.co.uk',
  },
};
